module.exports = __webpack_public_path__ + "static/media/LeadingAge Florida Logo.5b69c076.png";